module.exports = __webpack_public_path__ + "img/waiting.3c46b8a3.svg";